import axios from "axios"
import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeader, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { AprobarSolicitudesHEDTO } from "../Aprobacion Solicitudes/TypesAprobacionHE";

export const URL_CONTROLLER = `${configData.SERVER_URL}PresupuestoHorasExtras`

// export async function AprobarParcialmenteSolicitudHE(idSolicitud:number) {
//     return;
// }

export async function ObtenerHistorial(fecha:Date, estados:string) {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/DirectivoUnidad/HistorialSolicitudes`;
    var infoResponse: ResponseRequestGeneric<AprobarSolicitudesHEDTO[]|string> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader(),
                params : {
                    fecha,
                    estados
                }
            }
        )

        infoResponse.status = 200;
        infoResponse.dataResponse = respuesta.data;

    } catch (error) {
        infoResponse = hadleAxiosErrorResponse<AprobarSolicitudesHEDTO[]|string>(error)
    }
    return infoResponse;
}
